import { Link } from "react-router-dom";
import { COMPANY } from "../data/company";

// variant: "light" -> logo azul + texto oscuro (fondos claros)
//          "dark" -> logo negro/dorado + texto blanco (fondos oscuros)
//          "blue-on-dark" -> logo azul + texto blanco (footer oscuro)
export default function Logo({ variant = "light", withText = true, className = "" }) {
  const src = variant === "dark" ? "/logos/logo-dark.png" : "/logos/logo-light.png";
  const textColor = variant === "light" ? "text-brand-ink" : "text-white";
  const subColor = variant === "light" ? "text-brand-golddark" : "text-brand-gold";

  return (
    <Link
      to="/"
      data-testid="logo-home-link"
      className={`flex items-center gap-3 group ${className}`}
      aria-label={`${COMPANY.name} — Inicio`}
    >
      <img
        src={src}
        alt={`Logo de ${COMPANY.name}`}
        className="h-11 w-auto object-contain transition-transform duration-500 group-hover:rotate-[8deg]"
        width={48}
        height={48}
      />
      {withText && (
        <span className="flex flex-col leading-none">
          <span className={`font-display font-extrabold tracking-tight text-lg ${textColor}`}>
            {COMPANY.name}
          </span>
          <span className={`text-[10px] font-semibold uppercase tracking-[0.22em] ${subColor}`}>
            {COMPANY.legalTagline}
          </span>
        </span>
      )}
    </Link>
  );
}
